import { Building2, Check, ChevronsUpDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useT } from '../../i18n';
import { useAuthStore } from '../../auth/store';
import { Dropdown } from '../../ui';
import s from './OrgSwitcher.module.css';

/** Sélecteur d'organisation (une personne peut administrer plusieurs organisations, ex. MSP). */
export function OrgSwitcher({ collapsed }: { collapsed: boolean }) {
  const { t } = useT();
  const user = useAuthStore((x) => x.user);
  const orgId = useAuthStore((x) => x.orgId);
  const setOrgId = useAuthStore((x) => x.setOrgId);
  const navigate = useNavigate();
  const qc = useQueryClient();
  const memberships = user?.memberships ?? [];
  const current = memberships.find((m) => m.orgId === orgId);
  if (!current) return null;

  return (
    <Dropdown
      align="start"
      header={<span className={s.menuHeader}>{t('org.switch')}</span>}
      items={memberships.map((m) => ({
        id: m.orgId,
        label: (
          <span className={s.item}>
            <span>{m.orgName}</span>
            <small>{m.roleName}</small>
          </span>
        ),
        icon: m.orgId === orgId ? <Check size={16} /> : <span style={{ width: 16 }} />,
        onSelect: () => {
          if (m.orgId === orgId) return;
          setOrgId(m.orgId);
          qc.removeQueries({ queryKey: ['org'] });
          navigate('/');
        },
      }))}
      trigger={(props) => (
        <button type="button" className={s.trigger} {...props} title={collapsed ? current.orgName : undefined} aria-label={`${t('org.current')} : ${current.orgName}`}>
          <span className={s.avatar} aria-hidden="true">
            <Building2 size={18} />
          </span>
          {!collapsed && (
            <>
              <span className={s.text}>
                <span className={s.name}>{current.orgName}</span>
                <span className={s.role}>{current.roleName}</span>
              </span>
              {memberships.length > 1 && <ChevronsUpDown size={16} aria-hidden="true" />}
            </>
          )}
        </button>
      )}
    />
  );
}
